export function handleError<T>(response: Response, errorCallback: () => void): Promise<T> {
    if (response.status === 401) {
        errorCallback();
    }
    return response.json();
}